// questions.js
export const QUESTIONS = [{
		category: "吃",
		questions: [
			["1.园区有哪些美食?", "襄阳牛肉面热狗。关东煮、酸奶等小吃。"]
		]
	},
	{
		category: "住",
		questions: [
			["1.园内有住宿吗?", "九派通南苑、荆门九派通苑凯瑞酒店,咨询电话:0724-6509999"]
		]
	},
	{
		category: "行",
		questions: [
			["1.园内交通有哪些?", "园内有观光车,三人、四人扫码电动车"],
			["2.附近停车场?", "园博园东门、西门、南门都有停车场"],
			["3.园外交通有哪些?", "13路, 21路, 58路, 68路, 69路"]
		]
	},
	{
		category: "游",
		questions: [
			["1.游客服务中心电话?", "0724-6033555"],
			["2.水秀表演时间?", "每周六周天19:30-20:10"],
			["3.自然博物馆开放时间?", "周一闭馆, 周二至周天9:00-18:00"]
		]
	},
	{
		category: "购",
		questions: [
			["园内有购物吗?", "园内有美食, 工艺品等售卖"]
		]
	},
	{
		category: "娱",
		questions: [
			["1.有游客参与体验的项目吗?", "园区有非遗项目, 扎染、陶艺、皮影戏等。"]
		]
	}
];